import { render } from "./CausesChuteDeCheveux.vue?vue&type=template&id=68934dd6&scoped=true"
import script from "./CausesChuteDeCheveux.vue?vue&type=script&lang=js"
export * from "./CausesChuteDeCheveux.vue?vue&type=script&lang=js"

import "./CausesChuteDeCheveux.vue?vue&type=style&index=0&id=68934dd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68934dd6"]])

export default __exports__